import { render, staticRenderFns } from "./JcomTablePreview.vue?vue&type=template&id=2c0dd3e0"
import script from "./JcomTablePreview.vue?vue&type=script&lang=js"
export * from "./JcomTablePreview.vue?vue&type=script&lang=js"
import style0 from "./JcomTablePreview.vue?vue&type=style&index=0&id=2c0dd3e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports